var render = function (_h,_vm) {var _c=_vm._c;return (_vm.props.narrow)?_c('div',{class:[
    'container',
    _vm.data.class,
    _vm.data.staticClass
]},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-xl-9"},[_vm._t("default")],2)])]):_c('div',{class:[
    ("container" + (_vm.props.fluid ? '-fluid' : '')),
    _vm.data.class,
    _vm.data.staticClass
]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }